import { Box, Typography, useTheme } from "@mui/material";
import { useAtom, useSetAtom } from "jotai";
import {
  endUserSizeOptions,
  teamSizeLabels,
  teamSizeOptions,
} from "../constants/chipData";
import { formDataAtom, updateFieldAtom } from "../store/onboardingModalStore";
import { OnboardingSelectionChip } from "./shared/OnboardingSelectionChip";
import { OnboardingStepLayout } from "./shared/OnboardingStepLayout";

export const OnboardingTeamSize = (): JSX.Element | null => {
  const theme = useTheme();
  const [formData] = useAtom(formDataAtom);
  const updateField = useSetAtom(updateFieldAtom);

  const orgType = formData.orgType;
  if (!orgType) return null;

  const labels = teamSizeLabels[orgType];
  const endUserOptions = endUserSizeOptions[orgType];

  return (
    <OnboardingStepLayout title={labels.title} subtitle={labels.subtitle}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "28px" }}>
        {/* Team Members */}
        <Box>
          <Typography
            variant="body-medium"
            sx={{
              color: theme.palette.secondary["purple-tint"],
              marginBottom: "8px",
              display: "block",
            }}
          >
            {labels.teamLabel}
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {teamSizeOptions.map((option) => (
              <OnboardingSelectionChip
                key={option.value}
                label={option.label}
                isSelected={formData.teamSize === option.value}
                onClick={() => updateField({ teamSize: option.value })}
              />
            ))}
          </Box>
        </Box>

        {/* End Users / Employees */}
        <Box>
          <Typography
            variant="body-medium"
            sx={{
              color: theme.palette.secondary["purple-tint"],
              marginBottom: "8px",
              display: "block",
            }}
          >
            {labels.endUserLabel}
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {endUserOptions.map((option) => (
              <OnboardingSelectionChip
                key={option.value}
                label={option.label}
                isSelected={formData.endUserSize === option.value}
                onClick={() => updateField({ endUserSize: option.value })}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </OnboardingStepLayout>
  );
};
